<template>
  <div class="top-daily-fortune-base">
    <div class="image-banner" @click="onBannerClick"><img src="/static/img/banner/top_dailyfortune_banner.png"></div>
    <div class="lp-desktopSampleView" :data-visible="isModalVisible">
      <div class="lp-desktopSampleView__close" @click="closeModal">
        <span></span>
        <span></span>
      </div>
      <video
        :src="movieUrl"
        class="lp-desktopSampleView__video -normal"
        controls
        playsinline
        controlslist="nodownload"
        @click.prevent = "() => false"
        @ended="closeModal"
      ></video>
      <div class="background" @click="closeModal"></div>
    </div>
  </div>
</template>

<script>
export default {
  name: "topDailyFortune",
  data() {
    return {
      isModalVisible: false,
      targetUrl: '',
      videoList: [
        { url: '/daily/matatabi/movie/Neko_Honpen_card01.mp4', idx:  1 },
        { url: '/daily/matatabi/movie/Neko_Honpen_card02.mp4', idx:  2 },
        { url: '/daily/matatabi/movie/Neko_Honpen_card03.mp4', idx:  3 },
        { url: '/daily/matatabi/movie/Neko_Honpen_card04.mp4', idx:  4 },
        { url: '/daily/matatabi/movie/Neko_Honpen_card05.mp4', idx:  5 },
        { url: '/daily/matatabi/movie/Neko_Honpen_card06.mp4', idx:  6 },
        { url: '/daily/matatabi/movie/Neko_Honpen_card07.mp4', idx:  7 },
        { url: '/daily/matatabi/movie/Neko_Honpen_card08.mp4', idx:  8 },
        { url: '/daily/matatabi/movie/Neko_Honpen_card09.mp4', idx:  9 },
        { url: '/daily/matatabi/movie/Neko_Honpen_card10.mp4', idx: 10 },
        { url: '/daily/matatabi/movie/Neko_Honpen_card11.mp4', idx: 11 },
        { url: '/daily/matatabi/movie/Neko_Honpen_card12.mp4', idx: 12 },
        { url: '/daily/matatabi/movie/Neko_Honpen_card13.mp4', idx: 13 },
        { url: '/daily/matatabi/movie/Neko_Honpen_card14.mp4', idx: 14 },
        { url: '/daily/matatabi/movie/Neko_Honpen_card15.mp4', idx: 15 },
        { url: '/daily/matatabi/movie/Neko_Honpen_card16.mp4', idx: 16 },
        { url: '/daily/matatabi/movie/Neko_Honpen_card17.mp4', idx: 17 },
        { url: '/daily/matatabi/movie/Neko_Honpen_card18.mp4', idx: 18 },
        { url: '/daily/matatabi/movie/Neko_Honpen_card19.mp4', idx: 19 },
        { url: '/daily/matatabi/movie/Neko_Honpen_card20.mp4', idx: 20 },
        { url: '/daily/matatabi/movie/Neko_Honpen_card21.mp4', idx: 21 },
        { url: '/daily/matatabi/movie/Neko_Honpen_card22.mp4', idx: 22 },
        { url: '/daily/matatabi/movie/Neko_Honpen_card23.mp4', idx: 23 },
        { url: '/daily/matatabi/movie/Neko_Honpen_card24.mp4', idx: 24 },
        { url: '/daily/matatabi/movie/Neko_Honpen_card25.mp4', idx: 25 },
        { url: '/daily/matatabi/movie/Neko_Honpen_card26.mp4', idx: 26 },
        { url: '/daily/matatabi/movie/Neko_Honpen_card27.mp4', idx: 27 },
        { url: '/daily/matatabi/movie/Neko_Honpen_card28.mp4', idx: 28 },
        { url: '/daily/matatabi/movie/Neko_Honpen_card29.mp4', idx: 29 },
        { url: '/daily/matatabi/movie/Neko_Honpen_card30.mp4', idx: 30 },
        { url: '/daily/matatabi/movie/Neko_Honpen_card31.mp4', idx: 31 },
        { url: '/daily/matatabi/movie/Neko_Honpen_card32.mp4', idx: 32 },
        { url: '/daily/matatabi/movie/Neko_Honpen_card33.mp4', idx: 33 },
        { url: '/daily/matatabi/movie/Neko_Honpen_card34.mp4', idx: 34 },
        { url: '/daily/matatabi/movie/Neko_Honpen_card35.mp4', idx: 35 },
        { url: '/daily/matatabi/movie/Neko_Honpen_card36.mp4', idx: 36 },
        { url: '/daily/matatabi/movie/Neko_Honpen_card37.mp4', idx: 37 },
        { url: '/daily/matatabi/movie/Neko_Honpen_card38.mp4', idx: 38 },
        { url: '/daily/matatabi/movie/Neko_Honpen_card39.mp4', idx: 39 },
        { url: '/daily/matatabi/movie/Neko_Honpen_card40.mp4', idx: 40 },
        { url: '/daily/matatabi/movie/Neko_Honpen_card41.mp4', idx: 41 },
        { url: '/daily/matatabi/movie/Neko_Honpen_card42.mp4', idx: 42 },
        { url: '/daily/matatabi/movie/Neko_Honpen_card43.mp4', idx: 43 },
        { url: '/daily/matatabi/movie/Neko_Honpen_card44.mp4', idx: 44 },
        { url: '/daily/matatabi/movie/Neko_Honpen_card45.mp4', idx: 45 },
        { url: '/daily/matatabi/movie/Neko_Honpen_card46.mp4', idx: 46 },
        { url: '/daily/matatabi/movie/Neko_Honpen_card47.mp4', idx: 47 },
        { url: '/daily/matatabi/movie/Neko_Honpen_card48.mp4', idx: 48 },
        { url: '/daily/matatabi/movie/Neko_Honpen_card49.mp4', idx: 49 },
        { url: '/daily/matatabi/movie/Neko_Honpen_card50.mp4', idx: 50 },
        { url: '/daily/matatabi/movie/Neko_Honpen_card51.mp4', idx: 51 },
        { url: '/daily/matatabi/movie/Neko_Honpen_card52.mp4', idx: 52 },
        { url: '/daily/matatabi/movie/Neko_Honpen_card53.mp4', idx: 53 },
        { url: '/daily/matatabi/movie/Neko_Honpen_card54.mp4', idx: 54 },
        { url: '/daily/matatabi/movie/Neko_Honpen_card55.mp4', idx: 55 },
        { url: '/daily/matatabi/movie/Neko_Honpen_card56.mp4', idx: 56 },
        { url: '/daily/matatabi/movie/Neko_Honpen_card57.mp4', idx: 57 },
        { url: '/daily/matatabi/movie/Neko_Honpen_card58.mp4', idx: 58 },
        { url: '/daily/matatabi/movie/Neko_Honpen_card59.mp4', idx: 59 },
        { url: '/daily/matatabi/movie/Neko_Honpen_card60.mp4', idx: 60 },
        { url: '/daily/matatabi/movie/Neko_Honpen_card61.mp4', idx: 61 },
        { url: '/daily/matatabi/movie/Neko_Honpen_card62.mp4', idx: 62 },
        { url: '/daily/matatabi/movie/Neko_Honpen_card63.mp4', idx: 63 },
        { url: '/daily/matatabi/movie/Neko_Honpen_card64.mp4', idx: 64 },
        { url: '/daily/matatabi/movie/Neko_Honpen_card65.mp4', idx: 65 },
        { url: '/daily/matatabi/movie/Neko_Honpen_card66.mp4', idx: 66 },
        { url: '/daily/matatabi/movie/Neko_Honpen_card67.mp4', idx: 67 },
        { url: '/daily/matatabi/movie/Neko_Honpen_card68.mp4', idx: 68 },
        { url: '/daily/matatabi/movie/Neko_Honpen_card69.mp4', idx: 69 },
        { url: '/daily/matatabi/movie/Neko_Honpen_card70.mp4', idx: 70 },
        { url: '/daily/matatabi/movie/Neko_Honpen_card71.mp4', idx: 71 },
        { url: '/daily/matatabi/movie/Neko_Honpen_card72.mp4', idx: 72 },
        { url: '/daily/matatabi/movie/Neko_Honpen_card73.mp4', idx: 73 },
        { url: '/daily/matatabi/movie/Neko_Honpen_card74.mp4', idx: 74 },
        { url: '/daily/matatabi/movie/Neko_Honpen_card75.mp4', idx: 75 },
        { url: '/daily/matatabi/movie/Neko_Honpen_card76.mp4', idx: 76 },
        { url: '/daily/matatabi/movie/Neko_Honpen_card77.mp4', idx: 77 },
        { url: '/daily/matatabi/movie/Neko_Honpen_card78.mp4', idx: 78 },
      ],
      videoplayer: null
    }
  },
  props: {
    awsPrefix: {
      type: String,
      default: ''
    }
  },
  mounted() {
    this.videoplayer = this.$el.querySelector('video')
  },
  computed: {
    movieUrl() {
      return `${this.awsPrefix}${this.targetUrl }`
    }
  },
  methods: {
    onBannerClick(e) {
      this.isModalVisible = true
      const rndNum = parseInt(Math.random()*this.videoList.length)
      this.targetUrl = this.videoList[rndNum].url
      this.videoplayer.currentTime = 0
      window.gtag('event', 'Play', { event_category: 'MatatabiDaily', value: (rndNum + 1)})
      setTimeout(()=>this.videoplayer.play(), 500)
    },
    closeModal(e) {
      this.isModalVisible = false
      this.videoplayer.pause()
    }
  }
}
</script>

<style scoped lang="scss">
.top-daily-fortune-base {
  width: 100%;
  .image-banner {
    width: 100%;
    max-width: 580px;
    background: white;
    margin: 0 auto;
    cursor: pointer;
    position: relative;
    z-index: 0;
    img {
      width: 100%;
      display: block;
    }
  }
  video {
    position: relative;
    z-index: 100;
  }
  .lp-desktopSampleView__video {
    max-height: 390px;
    @media screen and (min-width: 375px) {
      max-height: 430px;
    }
    @media screen and (min-width: 580px) {
      max-height: 650px;
    }
  }
  .lp-desktopSampleView__close {
    z-index: 101;
  }
  .background {
    width: 100%;
    height: 100%;
    background: transparent;
    position: absolute;
    cursor: pointer;
    top: 0;
    left: 0;
  }
}
</style>



// WEBPACK FOOTER //
// ../../../../resources/assets/js/utvStore/components/TopDailyFortune.vue